<template>
    <div class="biz-new-contract">
        <modal class="house-list" :display="modalStatus.houseList" @modalStatus="closeModal()" >
            <h1>
                選擇房源
            </h1>
            <div class="group">
                <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
                <rent-select class="select-scroll" refName="member" selectMsg="所有業務" :isEdit="contractData.tenantNumber?true:false" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li :data-id="null" :data-name="null">所有業務</li>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="content">
                <div class="table-title">
                    <span class="name">房源名稱</span>
                    <span class="address">房源地址</span>
                    <span class="agent">業務</span>
                    <span class="rent">租金</span>
                </div>
                <div class="table-body">
                    <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                        <li v-for="(item, index) in filterByWord" :key="index">
                            <default-radio v-model="selectedHouseInfo.houseCid" :isPropChecked="false" :val="item.houseCid"></default-radio>
                            <span class="name">{{item.houseName}}</span>
                            <span class="address">{{item.address}}</span>
                            <span class="agent">{{item.agentName}}</span>
                            <span class="rent">{{toCurrency(item.rent)}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setHouseInfo(), closeModal()">確認</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="default-wrap contract-state">
            <div class="contract-state-wrap">
                <span class="progress">
                    <span class="progress-bar">
                        <span class="progress-status" :class="{'active': contractState == 1}">
                            1 合約資料
                        </span>
                        <span class="progress-hr"></span>
                        <span class="progress-status" :class="{'active': contractState == 2}">
                            2 上傳合約
                        </span>
                        <span class="progress-hr"></span>
                        <span class="progress-status" :class="{'active': contractState == 3}">
                            3 通知租客
                        </span>
                    </span>
                    
                </span>
            </div>
            <div class="btn-group">
                <button v-if="contractState == 3" class="default-button next" @click="toLeaseMgt(), $analyticsBiz.logEvent('查看進度', { screen_name: '查看進度'})">查看進度</button>
                <button v-if="contractState == 2" class="border-button save" @click="saveContract(1), $analyticsBiz.logEvent('儲存合約資料', { screen_name: '儲存合約資料'})">儲存</button>
                <button v-if="contractState == 1" class="default-button next" @click="nextStep(), $analyticsBiz.logEvent('下一步：上傳合約', { screen_name: '下一步：上傳合約'})">下一步：上傳合約</button>
                <button v-else-if="contractState == 2" class="default-button next" @click="saveContract(0), $analyticsBiz.logEvent('通知租客', { screen_name: '通知租客'})" >通知租客確認</button>
                <!-- <button class="default-button next" @click="saveContract(0)" >下一步：房東上傳</button> -->
            </div>
        </div>
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                租客資料
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="tanant-info">
                    <div class="tanant-info-wrap">
                        <div class="phone">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租客手機
                                </div>
                                <span v-show="error.tenantPhone" class="error-with-title">{{error.tenantPhone}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.tenantPhone}" type="text" v-model="contractData.tenantPhone" placeholder="請輸入手機號碼">
                            </div>
                        </div>
                        <div class="tanant-name">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租客姓名
                                </div>
                                <span v-show="error.tenantName" class="error-with-title">{{error.tenantName}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.tenantName}" type="text" v-model="contractData.tenantName" placeholder="請輸入真實姓名">
                            </div>
                        </div>
                        <div class="identification">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    身分證字號/居留證號
                                </div>
                                <span v-show="error.tenantIdNumber" class="error-with-title">{{error.tenantIdNumber}}</span>
                            </label>
                            <div class="input-arear">
                                <input :class="{error: error.tenantIdNumber}" type="text" v-model="contractData.tenantIdNumber" placeholder="請輸入內容">
                            </div>
                        </div>
                        <div class="upload-id">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    上傳身分證/居留證圖片(正反)
                                </div>
                                <span v-show="error.tenantIdCard" class="error-with-title">{{error.tenantIdCard}}</span>
                            </label>
                            <div class="input-arear">
                                <div class="upload-id-wrap">
                                    <div v-if="identification.font.length > 0"  class="list-upload font-side">
                                        <img  class="cancel" @click.prevent="identification.font = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                        <div  class="preview">
                                            <img :src="identification.font[0].blob" />
                                        </div>
                                    </div>
                                    <div v-else class="list-upload font-side">
                                        <file-upload
                                        v-if="identification.font.length == 0"
                                        class="upload-btn"
                                        post-action="/upload/post"
                                        input-id="font"
                                        :size="1024 * 5"
                                        :maximum="1"
                                        :multiple="true"
                                        v-model="identification.font"
                                        @input-filter="inputFilter"
                                        ref="font">
                                        <img v-if="identification.font.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                        正面
                                        </file-upload>
                                    </div>
                                    <div v-if="identification.back.length > 0" class="list-upload back-side">
                                        <img class="cancel" @click.prevent="identification.back = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                                        <div class="preview">
                                            <img  :src="identification.back[0].blob" />
                                        </div>
                                        <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    </div>
                                    <div v-else class="list-upload back-side">
                                        <file-upload
                                        v-if="identification.back.length == 0"
                                        class="upload-btn"
                                        post-action="/upload/post"
                                        input-id="back"
                                        :size="1024 * 5"
                                        :maximum="1"
                                        :multiple="true"
                                        v-model="identification.back"
                                        @input-filter="inputFilter"
                                        ref="back">
                                            <img v-if="identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                            反面
                                        </file-upload>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                選擇房源
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="house-select">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            選擇房源
                        </div>
                        <span v-show="error.houseCid" class="error-with-title">{{error.houseCid}}</span>
                    </label>
                    <div class="input-arear">
                        <div v-if="selectedHouseInfo.houseName" class="house-info-wrap">
                            <default-radio :isPropChecked="true"></default-radio>
                            <div class="house-info">
                                <div class="name">{{selectedHouseInfo.houseName}}</div>
                                <div class="address">{{selectedHouseInfo.address}}</div>
                                <div class="rent">租金：${{selectedHouseInfo.rent}}</div>
                            </div>
                            <button  class="border-button" @click="choseHouse(), $analyticsBiz.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇其他房源</button>
                        </div>
                        <button v-else class="border-button chose-house" @click="choseHouse(), $analyticsBiz.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇房源</button>
                        <button v-if="selectedHouseInfo.houseName" class="border-button-gray edit-house" @click="editHouse()">編輯房源</button>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 1">
            <div class="toogle-title" slot="toogle-title">
                合約資料
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="contract-info">
                    <div class="contract-info-wrap">
                        <div class="three-part move-in-date">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    租約起訖日
                                </div>
                                <span v-show="error.dateErr" class="error-with-title">{{error.dateErr}}</span>
                            </label>
                            <div class="input-arear">
                                <date-picker v-model="datePeriod.contractPeriod" :class="{'active': contractData.contractBeginTime != null, 'error': error.dateErr}" :disabled-date="notBeforeThisday" placeholder="2020.05.06-2021.05.06" format="YYYY-MM-DD" valueType="format" rangeSeparator="-" range  ></date-picker>
                            </div>
                        </div>
                        <div class="three-part desposit">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    入住人數
                                </div>
                                <span v-show="error.tenantNumber" class="error-with-title">{{error.tenantNumber}}</span>
                            </label>
                            <div class="input-arear">
                                <rent-select :class="{error: error.tenantNumber}" class="select-scroll" refName="tenantNumber"  :selectMsg="contractData.tenantNumber?contractData.tenantNumber+'個人':'請選擇入住人數'" :isEdit="contractData.tenantNumber?true:false" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="n in 100" :key="n" :data-id="n">
                                            {{n}} 個人
                                        </li>
                                    </ul>
                                </rent-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="contractState == 2">
            <div class="toogle-title" slot="toogle-title">
                上傳合約
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="contract-file-wrap">
                    <div class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                紙本合約 PDF
                            </div>
                            <span v-show="error.tenantPhone" class="error-with-title">{{error.tenantPhone}}</span>
                        </label>
                        <div class="input-arear">
                            <div v-if="paperContract.length == 0" class="cover-block" :class="{'img-error': error.paperContract}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="paperContract"
                                @input-filter="inputPaperContractFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳PDF
                                </file-upload>
                            </div>
                            <div v-else class="cover-preview">
                                <div class="preview">
                                    <span v-if="paperContract[0].type == 'application/pdf'">
                                        {{paperContract[0].name}}
                                    </span>
                                    <img v-else :src="paperContract[0].blob" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="paperContract"
                                    @input-filter="inputPaperContractFilter"
                                    ref="uploadCover">
                                        取代文件
                                </file-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <div v-if="contractState == 3" class="default-wrap notify">
            <img class="success" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
            <div class="title">
                已通知租客確認
            </div>
            <div class="description">
                我們已發簡訊通知租客，您可以下載 App 追蹤進度，我們也會發送推播，通知您租客的簽約進度。
            </div>
            <!-- <div class="qr">
                <vue-qrious :value="hostUrl"  :size="size" level="L"/>
                掃碼下載 App
            </div> -->
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import FileUpload from 'vue-upload-component';
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import DefaultRadio from '@/components/widge/DefaultRadio.vue';
import Modal from '@/components/widge/Modal.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'

const today = new Date();
today.setHours(0, 0, 0, 0);
// console.log(today)
export default {
    data () {
        return {
            modalHeight: (window.innerHeight-400) + 'px',
            componentKey: 0,
            contractData: {},
            datePeriod: [],
            identification: {},
            paperContract: [],
            paperContractType: null,
            uploadLimit: 100,
            isDefault: false,
            filter: {
                word: null,
                agent: null
            },
            error: {
                tenantPhone: null,
                tenantName: null,
                tenantIdNumber: null,
                dateErr: null,
                tenantNumber: null,
                tenantIdCard: null
            },
            isDefault: false,
            selectedHouseInfo: {},
            modalStatus: {
                houseList: false
            },
        }
    },
    mounted() {
        this.$store.dispatch('getBizGetAvailableHouse')
        .then(()=>{
            if(this.pcontractSelectedHouse.seleted != null){
                this.setHouseInfo()
            }
        })
        this.$store.dispatch('getBizMemberByGroupList')
    },
    destroyed() {
        if( this.contractState != 1 ){
            this.$store.dispatch('bizSetNewContractDefault')
        }
    },
    watch: {
        // $route: {
        //     handler: function (val) {
        //         console.log(val)
        //         if( this.contractState != 1 ){
        //             this.$store.dispatch('bizSetNewContractDefault')
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // },
        contractData: {
            handler: function (newValue, oldValue) {
                console.log(newValue)
                let phoneReg = /^09[0-9]{8}$/
                if(newValue.tenantPhone){
                    if( phoneReg.test(newValue.tenantPhone) ){
                        this.error.tenantPhone = null
                    }else{
                        this.error.tenantPhone = '格式不符'
                    }
                }
                if(newValue.tenantName){
                    this.error.tenantName = null
                }
              
                if(newValue.tenantIdNumber){
                    if(newValue.tenantIdNumber.length === 10){
                        this.error.tenantIdNumber = null
                    }else{
                        this.error.tenantIdNumber = '身分證格式錯誤'
                    }
                }
                if(newValue.contractBeginTime){
                    this.error.dateErr = null
                }
                // if(newValue.houseCid){
                //     this.error.houseCid = null
                // }
                // console.log(new Date(newValue.contractEndTime) < today)
               if(newValue.contractEndTime && new Date(newValue.contractEndTime) < today){
                    this.error.dateErr = '租約訖日不可早於今日'
                }else if(newValue.contractEndTime){
                    this.error.dateErr = null
                }
        
               if(newValue.tenantNumber){
                    this.error.tenantNumber = null
                }
                this.$store.dispatch('setBizNewContract', newValue)
            },
            deep:true
        },
        identification: {
            handler: function (val) {
                if(val.back.length && val.font.length){
                    this.error.tenantIdCard = null
                }
                this.$store.dispatch('bizSetNewContractIdentification', val)
            },
            deep:true
        },
        paperContract: {
            handler: function (newValue, oldValue) {
                if( this.paperContractType == 'image' ){
                    this.paperContract.map( (contractItem, index) => {
                        if(/\.(pdf)$/i.test(contractItem.name)){
                            this.paperContract.splice(index,1);
                        }
                    });
                }else{
                    this.paperContract.map( (contractItem, index) => {
                        if(/\.(jpeg|jpe|jpg|png)$/i.test(contractItem.name)){
                            this.paperContract.splice(index,1);
                        }
                    });
                }
                this.$store.dispatch('setBizNewContractPaper', newValue)
            },
            deep:true
        },
        'datePeriod.contractPeriod': function (newValue, oldValue){
            this.contractData.contractBeginTime = newValue[0]
            this.contractData.contractEndTime = newValue[1]
        },
        pcontractData: {
            handler:  function (val) {
                console.log(val)
                this.contractData = val
            },
            immediate: true
        },
        pcontractIdCard: {
            handler:  function (val) {
                this.identification = val
            },
            immediate: true
        },
        pcontractDatePeriod: {
            handler:  function (val) {
                this.datePeriod = val
            },
            immediate: true
        },
        pcontractSelectedHouse: {
            handler:  function (val) {
                this.selectedHouseInfo = val
            },
            immediate: true
        },
        paperContractType: function (val) {
            this.$store.dispatch('setBizNewContractPaperType', val)
        },
        // uploadStatus: {
        //     handler: function (val) {
        //         if(val.status == true){
        //             this.$store.dispatch('setAlarmStatus', {status: true,title: val.msg,type: 'error'})
        //         }
        //     },
        //     deep: true,
        //     immediate: true

        // },
        notifyStatus: {
            handler: function (val) {
                console.log(val)
                if(val.status == true){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: val.msg,type: 'success'})
                }
            },
            deep: true,
            immediate: true
        },
        
    },
    methods: {
        setFilterWord: function (value) {
            this.filter.word = value
        },
        getSelectId: function (value) {
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'tenantNumber' ){
                this.contractData.tenantNumber = targetId
            }else if( value.ref == 'member' ){
                this.filter.agent = value.name
            }
        },   
        choseHouse: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.modalStatus.houseList = true
        },
        setHouseInfo: function () {
            let house = null
            this.houseList.forEach(element => {
                console.log(element)
                if(element.houseCid === this.selectedHouseInfo.houseCid){
                    house =  element
                }
            });
            this.contractData.houseCid = house.houseCid
            this.selectedHouseInfo = Object.assign({}, house)
            this.$store.dispatch('bizSetNewContractSelectedHouse', this.selectedHouseInfo)
            this.$store.dispatch('getBizGetContractPeriod', this.selectedHouseInfo.houseCid)
        },
        closeModal: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.modalStatus.houseList = false
            this.setFilterDefault()
        },
        setFilterDefault: function () {
            this.filter = {
                word: null,
                agent: null
            }
        },     
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳JPG或PNG檔案',type: 'error'})
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        checkTwID: function (id){
            //建立字母分數陣列(A~Z)
            var city = new Array(
                1,10,19,28,37,46,55,64,39,73,82, 2,11,
                20,48,29,38,47,56,65,74,83,21, 3,12,30
            )
            id = id.toUpperCase();
            // 使用「正規表達式」檢驗格式
            if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
                return false;
            } else {
                //將字串分割為陣列(IE必需這麼做才不會出錯)
                id = id.split('');
                //計算總分
                var total = city[id[0].charCodeAt(0)-65];
                for(var i=1; i<=8; i++){
                    total += eval(id[i]) * (9 - i);
                }
                //補上檢查碼(最後一碼)
                total += eval(id[9]);
                //檢查比對碼(餘數應為0);
                return ((total%10 == 0 ));
            }
        },
        inputBackFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        inputPaperContractFilter: function (newFile, oldFile, prevent) {

            if (newFile && !oldFile) {
                // Filter non-image file
                // if (!/\.(jpeg|jpe|jpg|png|pdf)$/i.test(newFile.name)) {
                //     return prevent()
                // }else 
                if (/\.(pdf)$/i.test(newFile.name)) {
                    this.paperContractType = 'pdf'
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳PDF檔案',type: 'error'})
                    return prevent()
                }
                if(newFile.size > (1024*1024*10)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制10MB',type: 'error'})
                    return prevent()
                }
                // else if(/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)){
                //     this.paperContractType = 'image'
                // }
            }
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        saveContract: function (action) {
            // console.log('saveContract')
            if(this.checkContract()){
                this.$store.dispatch('saveBizNewContract', action)
                // .then(()=>{
                //     this.$store.dispatch('bizSetNewContractStatus', 1)
                // })
            }
        },
        nextStep: function () {
            console.log(this.checkInput())
            if( this.contractState == 1 && this.checkInput()){
                this.$store.commit('bizNewContract/set_contract_status', 2)
            }
        },
        // savePaperContract: function (action) {
        //     // console.log('savePaperContract')
        //     if( this.contractState == 2){
        //         this.$store.dispatch('saveNewContratFile', action)
        //     }
            
        // },
        toLeaseMgt: function () {
            // window.location.href = '/bussiness/mgtCategory/leaseMgt/?success=1&type=2#紙本確認中'
            this.$router.push({name: 'bizLeaseMgtDefault', hash: '#紙本確認中'})
            this.$store.dispatch('bizSetNewContractDefault')
            this.$store.dispatch('bizSetNewContractStatus', 1)
            this.$store.dispatch('setAlarmStatus', {status: true,title: '成功新增紙本合約',description: '飛豬管家已發送簡訊通知房客進行合約確認，您也可以主動通知房客',type: 'success'})

        },
        checkInput: function () {
            if(!this.contractData.tenantPhone){
                this.error.tenantPhone = '請填寫租客手機'
            }
            if(!this.contractData.tenantName){
                this.error.tenantName = '請填寫租客姓名'
            }else{
                this.error.tenantName = null
            }
            if(!this.contractData.tenantIdNumber){
                this.error.tenantIdNumber = '請填寫身份字號'
            }
            if(!this.contractData.contractBeginTime){
                this.error.dateErr = '請填寫租約起訖日'
            }
            if(!this.contractData.tenantNumber){
                this.error.tenantNumber = '請填寫入住人數'
            }
            // if(!this.contractData.houseCid){
            //     this.error.houseCid = '請填寫房源'
            // }
            if(!this.identification.font.length){
                this.error.tenantIdCard = '請上傳身分證圖片'
            }
            if(!this.identification.back.length){
                this.error.tenantIdCard = '請上傳身分證圖片'
            }

            if(
                this.contractData.tenantName &&
                this.contractData.tenantPhone &&
                this.contractData.tenantIdNumber &&
                this.contractData.contractBeginTime &&
                this.contractData.contractEndTime &&
                this.contractData.tenantNumber &&
                this.error.tenantPhone == null  &&
                this.error.tenantIdNumber == null  &&
                this.error.tenantIdCard == null &&
                this.error.dateErr == null 
            ){
                return true
            }else{
                return false
            }
        },
        checkContract: function () {
            if(this.paperContract.length > 0){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '未上傳紙本合約',type: 'error'})

                return false
            }
        },
        notBeforeThisday(date) {
            let contractPeriod = this.pcontractPeriod
            if(contractPeriod.length){
                for (let i = 0; i < contractPeriod.length; i++) {
                    const element = contractPeriod[i];
                    
                    if(element.contractBeginTime-86400000 < date &&  element.contractEndTime+86400000 > date){
                        return true
                    }
                }
            }
        },
        editHouse(){
            if(this.selectedHouseInfo.houseStatus !== 2){
                this.$router.push({name: 'bizEditHouse', query: {'cid': this.selectedHouseInfo.houseCid,'type': 'contract'}})
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error'})
            }
        }
    },
    computed:{
        filterBySales: function () {
            return this.houseList.filter((item) => {
                if(this.filter.agent){
                    if(item.agentName == this.filter.agent ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterBySales.filter((item) => {
                if( this.filter.word ){
                    if( item.address.includes(this.filter.word)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            houseList: 'GET_BIZ_ECONTRACT_AVAILABLE_HOUSE',
            contractState: 'GET_BIZ_CONTRACT_STATUS',
            uploadStatus: 'GET_BIZ_UPLOAD_STATUS',
            notifyStatus: 'GET_BIZ_NOTIFY_STATUS',
            pcontractData: 'GET_BIZ_CONTRACT_DATA',
            pcontractIdCard: 'GET_BIZ_CONTRACT_IDENTIFICATION',
            pcontractDatePeriod: 'GET_BIZ_CONTRACT_DATE_PERIOD',
            pcontractSelectedHouse: 'GET_BIZ_CONTRACT_SELECTED_HOUSE',
            pcontractPeriod: 'GET_BIZ_CONTRACT_PERIOD',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
        })
    },
    components: {
        RentSelect,
        DatePicker,
        FileUpload,
        Modal,
        toogleBlock,
        DefaultRadio,
        TableSearch
    }
}
</script>
<style lang="scss" scoped>
    .biz-new-contract{
        position: relative;
        margin-bottom: 300px;
        #modal.house-list{
            .modal-content{
                width: 900px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        display: flex;
                        font-size: 24px;
                        margin: auto;
                        margin-top: 32px;
                        margin-bottom: 32px;
                    }
                    .group{
                        display: flex;
                        margin-bottom: 12px;
                        .table-search{
                            width: 573px;
                            margin-right: 10px;
                        }
                        .biz-rent-select{
                            width: 216px;
                        }
                    }
                    .content{
                        width: 833px;
                        margin-bottom: 8px;
                        padding: 0px 32px;
                        .table-title{
                            padding: 20px 0;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                            .name{
                                width: 235px;
                                margin-left: 57px;
                                margin-right: 50px;
                            }
                            .address{
                                width: 265px;
                                margin-right: 50px;
                            }
                            .agent{
                                width: 50px;
                                margin-right: 50px;
                            }
                        }
                        .table-body{
                            ul{
                                height: 360px;
                                overflow-x: hidden;
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 20px 0;
                                    border-bottom: 1px solid #F1F5F4;
                                    .name{
                                        width: 235px;
                                        margin-left: 24px;
                                        margin-right: 50px;
                                    }
                                    .address{
                                        width: 265px;
                                        margin-right: 50px;
                                    }
                                    .agent{
                                        width: 50px;
                                        margin-right: 50px;
                                    }
                                }
                            }
                            ul::-webkit-scrollbar {
                                display: none;
                            }
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                    }
                }
            }
        }
        .contract-state{
            position: relative;
            display: flex;
            align-items: center;
            width: 1140px;
            height: 92px;
            margin-bottom: 20px;
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-status{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    background-color: #ffffff;
                    color: #a19d9c;
                    width: 204px;
                    height: 44px;
                    .order{
                        font-size: 12px;
                        margin-right: 4px;
                    }
                }
                .progress-status.active{
                    color: #3942b5;
                    border: solid 1px #3942b5;
                    background-color: rgba(57, 66, 181, 0.06);
                }
                .progress-hr{
                    width: 44px;
                    height: 1px;
                    background: #cacfcd;
                }
            }
            .btn-group{
                position: absolute;
                display: flex;
                right: 24px;
                .save{
                    width: 132px;
                    margin-right: 12px;
                }
                .next{
                    width: 200px;
                }
                .view-biz-new-contract{
                    width: 200px;
                    height: 44px;
                    cursor: pointer;
                }
            }
        }
        .biz-rent-select{
            background: #fff;
        }
        .biz-rent-select.error{
            bottom: unset;
            left: unset;
        }
        .tanant-info{
            .tanant-info-wrap{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                >div{
                    width: 324px;
                    margin-right: 60px;
                    margin-bottom: 24px;
                    input{
                        width: 100%;
                        height: 44px;
                    }
                }
                >div:nth-child(3n){
                    margin-right: 0px;
                }
                .upload-id{
                    .upload-id-wrap{
                        display: flex;
                        .list-upload{
                            position: relative;
                            width: 124px;
                            height: 93px;
                            margin-right: 10px;
                            border-radius: 4px;
                            border: dashed 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            .upload-icon{
                                width: 24px;
                                height: 24px;
                                margin-bottom: 4px;
                            }
                            .cancel{
                                position: absolute;
                                cursor: pointer;
                                top: -14px;
                                right: -14px;
                            }
                            .preview{
                                width: 124px;
                                height: 93px;
                                display: flex;
                                align-items: center;
                                border-radius: 4px;
                                overflow: hidden;
                                >img{
                                    width: 100%;
                                }
                            }
                            .file-uploads{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    
                }
            }
            
        }
        .contract-info{
            .contract-info-wrap{
                display: flex;
                flex-wrap: wrap;
                .house-address{
                    >label{
                        width: 1044px;
                    }
                    .input-arear{
                        position: relative;
                        margin-bottom: 14px;
                        display: flex;
                        flex-wrap: wrap;
                        > div{
                            margin-right: 12px;
                            margin-bottom: 16px;
                        }
                        > div:nth-child(-n+2){
                            width: 196px;
                        }
                        > div:nth-child(n+4){
                            color: #525956;
                            input{
                                width: 196px;
                                height: 44px;
                                margin-bottom: 0px;
                            }
                        }
                        .biz-rent-select{
                            box-sizing: border-box;
                        }
                        .select-road{
                            width: 196px;
                            input{
                                width: 100%;
                            }
                        }
                    }
                    
                }
                .three-part{
                    width: 324px;
                    margin-right: 60px;
                    margin-bottom: 24px;
                    input{
                        width: 100%;
                    }
                }
                >div:nth-child(4n){
                    margin-right: 0px;
                }
                .move-in-date{
                    position: relative;
                    .mx-datepicker{
                        width: 324px;
                        input{
                            width: 100%;
                            height: 44px;
                            border-radius: 4px;
                            border: solid 1px #f3f3f3;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        input{
                            border: 1px solid #e0dfde !important;
                            color: #e0dfde !important;
                        }
                        i{
                            color: #e0dfde;
                        }
                    }
                    .mx-datepicker.errorr{
                        input{
                            border: 1px solid #fc7171 !important;
                        }
                    }
                }
                span.error{
                    bottom: unset;
                    left: unset;
                }
            }
        }
        .contract-file-wrap{
            display: flex;
            align-items: center;
            .image-cover{
                .cover-block{
                    position: relative;
                    width: 124px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 24px;
                        margin-bottom: 4px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .img-error{
                        position: absolute;
                        width: 200px;
                        left: 136px;
                        font-weight: 500;
                        font-size: 12px;
                        color:  #F05A3E;
                        top: unset;
                    }
                }
                .cover-block.img-error{
                    border: dashed 1px #F05A3E;
                }
                .cover-preview{
                    display: flex;
                    align-items: center;
                    .preview{
                        display: flex;
                        margin-right: 8px;
                        align-items: center;
                        color: #ff9275;
                        text-decoration: underline;
                    }
                    .replace{
                        width: 104px;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
        // .contract-list{
        //     ul{
        //         display: flex;
        //         flex-wrap: wrap;
        //         li{
        //             position: relative;
        //             margin-right: 16px;
        //             .preview{
        //                 width: 150px;
        //             }
        //             .cancel{
        //                 position: absolute;
        //                 cursor: pointer;
        //                 top: -14px;
        //                 right: -14px;
        //             }
        //         }
        //     }
        // }
            
        .notify{
            position: relative;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-items: center;
            .success{
                width: 50px;
                margin-top: 30px;
                margin-bottom: 22px;
            }
            .title{
                display: flex;
                align-items: center;
                font-size: 24px;
                font-weight: 500;
                margin-bottom: 14px;
                img{
                    margin-right: 12px;
                }
            }
            .description{
                width: 368px;
                font-weight: 300;
                line-height: 1.7;
                margin-bottom: 20px;
            }
            .qr{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-bottom: 30px;
                img{
                    padding: 10px;
                    background: #fff;
                    margin-bottom: 12px;
                }
            }
        }
        .house-select{
            .chose-house{
                width: 324px;
            }
            .edit-house{
                width: 120px;
            }
            .house-info-wrap{
                position: relative;
                display: flex;
                align-items: center;
                width: 546px;
                height: 108px;
                border-radius: 4px;
                border: solid 1px #ff9275;
                background: #fff;
                padding: 16px 24px 16px 24px;
                box-sizing: border-box;
                margin-right: 12px;
                .dafault-checkbox{
                    margin-bottom: 0px;
                }
                .house-info{
                    margin-left: 22px;
                    >div{
                        margin-bottom: 6px;
                    }
                }
                >button{
                    position: absolute;
                    right: 40px;
                    height: 44px;
                    border: none;
                }
            }
            .input-arear{
                display: flex;
                align-items: center;
            }
        }
    }
    // @media screen and (max-width: 1280px) {
    //     .biz-new-contract{
    //         .contract-state{
    //             width: 1096px;
    //         }
    //         .tanant-info{
    //             .tanant-info-wrap{
    //                 >div{
    //                     margin-right: 109px;
    //                 }
    //             }
    //         }
    //         .contract-info{
    //             .contract-info-wrap{
    //                 .three-part{
    //                     margin-right: 109px;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/newContract/NewContract.vue